/* eslint-disable no-restricted-globals */
import moment from 'moment';
import ptBR from 'rsuite/locales/pt_BR';
import enUs from 'rsuite/locales/en_US';
import itIt from 'rsuite/locales/it_IT';
import deDe from 'rsuite/locales/de_DE';
import frFR from 'rsuite/locales/fr_FR';
import 'moment/locale/fr';
import 'moment/locale/pt-br';
import 'moment/locale/it';
import 'moment/locale/de';

const language = JSON.parse(localStorage.getItem('language'));

export const returnRsuiteLocale = () => {
  switch (language?.value) {
    case 'fr':
      return frFR;
    case 'pt':
      return ptBR;
    case 'it':
      return itIt;
    case 'de':
      return deDe;
    default:
      return enUs;
  }
};

export const returnMomentLocale = () => {
  switch (language?.value) {
    case 'fr':
      moment.locale('fr');
      break;
    case 'pt':
      moment.locale('pt-br');
      break;
    case 'it':
      moment.locale('it');
      break;
    case 'de':
      moment.locale('de');
      break;
    default:
      moment.locale('en-us');
      break;
  }
};
